// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import { Warning } from '../'

import { LoadingAmount } from './LoadingAmount'

import { PicsaDeductionsAmountGrid as AmountGrid } from './PicsaDeductionsAmountGrid'

import {
  showAsCurrency,
  getTotal,
  decodeBase64
} from '../../utils'

const QUERY_IDENTITY_PAYMENTS = gql`
  query($identityId: ID!, $batchPaymentId: UUID!) {
    identity(id: $identityId) {
      id
      firstName
      lastName
      identityValue
      client {
        id
        employeeNumber
      }
      paymentsFor(transactedIn_Id: $batchPaymentId) {
        totalCount
        edges {
          node {
            id
            amount
            prod {
              id
              defaultShortCode
              family
            }
          }
        }
      }
    }
  }
`


export const PicsaDeductions = ({ identityId, batchPaymentId }) => (
  <Query query={QUERY_IDENTITY_PAYMENTS} variables={{ identityId, batchPaymentId: decodeBase64(batchPaymentId) }}>
    {({ loading, error, data}) => {
      if (loading) {
        return <AmountGrid singleValue={<LoadingAmount />} />
      }

      if (error) {
        return <AmountGrid singleValue={<Warning iconSize='small' />} />
      }

      const investmentPayments = data.identity.paymentsFor.edges.filter(({ node: payment }) => (
        payment.prod.family === 'INVESTMENTS'
      ))
      const insurancePayments = data.identity.paymentsFor.edges.filter(({ node: payment }) => (
        payment.prod.family === 'INSURANCE'
      ))
      const creditPayments = data.identity.paymentsFor.edges.filter(({ node: payment }) => (
        payment.prod.family === 'CREDIT'
      ))
      const feePayments = data.identity.paymentsFor.edges.filter(({ node: payment }) => (
        payment.prod.defaultShortCode.includes('_fee')  // catches 'solution_fee' (Solution) & 'rewards_fee' (EarnBacks)
      ))

      const investmentPaymentTotal = getTotal(investmentPayments.map(({ node: payment }) => payment.amount))
      const insurancePaymentTotal = getTotal(insurancePayments.map(({ node: payment }) => payment.amount))
      const creditPaymentTotal = getTotal(creditPayments.map(({ node: payment }) => payment.amount))
      const feePaymentTotal = getTotal(feePayments.map(({ node: payment }) => payment.amount))

      return (
        <AmountGrid
          investment={showAsCurrency('R', investmentPaymentTotal)}
          insurance={showAsCurrency('R', insurancePaymentTotal)}
          credit={showAsCurrency('R', creditPaymentTotal)}
          fees={showAsCurrency('R', feePaymentTotal)}
        />
      )
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-income/PicsaDeductions.js